<template>
    <div :id="submenu.title.replaceAll('&', '').replaceAll(' ', '-').toLowerCase()" v-if="submenu.visible">
        <Link

            :href="`${submenu.route.includes('http') ? submenu.route : route(submenu.route)}`"
            class="inline-flex items-center px-2 py-2 font-semibold text-xs
                                              uppercase tracking-widest focus:outline-none focus:shadow-outline-gray
                                               transition ease-in-out duration-700 text-nowrap whitespace-nowrap"
            aria-current="page"
            :class="{'text-indigo-500':submenu.active,'text-gray-800 hover:text-indigo-500':!submenu.active}"
            v-if="submenu.visible">{{ submenu.title }}
        </Link>
        <hr class="border-t-4 border-gray-800 rounded-t-md"
            :class="{'block':submenu.active,'hidden':!submenu.active}"
            v-if="submenu.visible"/>
    </div>
</template>
<script setup>
import {Link} from "@inertiajs/inertia-vue3";
import {onMounted} from "vue";

const props = defineProps({
    submenu: [Object, Array]
})

onMounted(() => {
    if (props.submenu.active) {
        scrollToElement(props.submenu.title.replaceAll('&', '').replaceAll(' ', '-').toLowerCase());
    }
})

function scrollToElement(elementId) {
    const element = document.getElementById(elementId);
    if (element) {
        element.scrollIntoView({behavior: 'instant', block: 'nearest', inline: 'center'});
    }
}
</script>
